import { FormControl, FormLabel, Input, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Text } from "@chakra-ui/react";
import { memo, useCallback } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import FlowNode from "./FlowNode";

interface StartTimerNodeData extends NodeData {
  displayName: string;
  limit: number;
}

function StartTimerNode(props: NodeProps<NodeType<StartTimerNodeData>>) {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const formData = nodeData as StartTimerNodeData | undefined;
  const displayName = formData?.displayName ?? "";
  const limit = formData?.limit ?? 0;

  const { register, handleSubmit } = useForm<StartTimerNodeData>({
    defaultValues: {
      displayName, limit,
    },
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData(nodeId);

  const handleUpdate = useCallback(
    ({ displayName, limit }: StartTimerNodeData) => {
      updateNodeData({ displayName, limit});
    },
    [updateNodeData]
  );

  return (
    <FlowNode {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <FormControl>
          <FormLabel>
            <Text casing={"uppercase"} color={color}>
              Display Name
            </Text>
          </FormLabel>
          <Input id={"flagName"} {...register("displayName")} color={color} />
        </FormControl>
        <FormControl>
          <FormLabel>
            <Text casing={"uppercase"} color={color}>
              Limit (s)
            </Text>
          </FormLabel>
          <NumberInput step={60} defaultValue={0} min={0}>
            <NumberInputField id={"limit"} {...register("limit")} color={color} />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </FormControl>

      </form>
    </FlowNode>
  );
}

export default memo(StartTimerNode);
